import React from 'react';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import useModalStore from '@/stores/useModalStore';
import IconCross from '@/assets/icons/cross.svg';
import { useEffect } from "react";
import { useLocation } from "wouter";
import Logo from "@/components/Logo";
import useConnectWithX from "@/hooks/useConnectWithX";
import useConnectWithGoogle from "@/hooks/useConnectWithGoogle";
import { useAuthStore } from "@/hooks/useAuthStore";
import { trackEvent } from "@/utils/analytics";
import { EventAction } from "@/types/analytics";
import { getXDaoHomePath } from "@/lib/utils";
import IconX from "@/assets/icons/x.svg";
import IconGoogle from "@/assets/icons/google.svg";
import AccountExistsModal from "@/components/AccountExistsModal";

const LoginModal = () => {
  const [_, setLocation] = useLocation();
  const { isAuthenticated } = useAuthStore();
  const connectWithX = useConnectWithX().connectWithX;
  const connectWithGoogle = useConnectWithGoogle().connectWithGoogle;
  const { login, setLoginModal } = useModalStore();
  const { show: showModal } = login;

  // Extract redirect parameter from URL
  const urlParams = new URLSearchParams(window.location.search);
  const redirectPath = urlParams.get("redirect");

  // If user is already authenticated, redirect them to their intended destination
  useEffect(() => {
    if (isAuthenticated) {
      setLocation(redirectPath || getXDaoHomePath());
    }
  }, [isAuthenticated, redirectPath, setLocation]);

  const handleXLogin = async () => {
    trackEvent('ui_interaction', EventAction.BUTTON_CLICK, {
      label: 'login_connect_x',
      component: 'login_page',
      location: 'connect_button',
      button_type: 'primary',
    });
    
    if (redirectPath) {
      sessionStorage.setItem("redirectAfterLogin", redirectPath);
    }

    await connectWithX();
  };

  const handleGoogleLogin = async () => {
    trackEvent('ui_interaction', EventAction.BUTTON_CLICK, {
      label: 'login_connect_google',
      component: 'login_page',
      location: 'connect_button',
      button_type: 'secondary',
    });
    
    if (redirectPath) {
      sessionStorage.setItem("redirectAfterLogin", redirectPath);
    }

    await connectWithGoogle();
  };


  return (
    <>
      <Dialog
        open={showModal}
        onOpenChange={() => {/* Blocking - no close */}}
      >
      <DialogContent
        className="w-[90%] max-w-[800px] bg-backgroundGray border-backgroundGray"
        shouldShowCloseButton={false}
      >
        <DialogHeader>
          <DialogTitle className="text-white text-xl font-inter flex items-center justify-end">
            <DialogClose asChild>
              <img
                  src={IconCross}
                  alt="cross"
                  className="w-[1.88rem] h-[1.88rem] hover:cursor-pointer"
                  onClick={() => {
                    setLoginModal({ show: false });
                  }}
              />
            </DialogClose>
          </DialogTitle>
        </DialogHeader>
        <div className="flex flex-col items-center gap-6 sm:gap-8 mt-2 mb-8 sm:mb-16">
          <Logo size="lg" />
          <p className="text-center max-w-lg text-base sm:text-lg text-gray-300 px-4">
            Tweetonium is the Next Frontier of Decentralized Asset Ownership through an NFT-powered DAO with Performance-Backed Equity Derivatives.
          </p>
          
          {/* X/Twitter Login Button */}
          <button
            className="py-3 sm:py-[14px] px-8 sm:px-16 bg-white rounded-full flex flex-row items-center gap-3 w-full max-w-[18.75rem] justify-center"
            onClick={handleXLogin}
          >
            <img
              className="w-5 h-5"
              src={IconX}
              alt="X icon"
            />
            <span className='font-inter font-semibold text-sm text-[#121212]'>
              Login with X/Twitter
            </span>
          </button>

          {/* Google Login Button */}
          <button
            className="py-3 sm:py-[14px] px-8 sm:px-16 bg-white rounded-full flex flex-row items-center gap-3 w-full max-w-[18.75rem] justify-center"
            onClick={handleGoogleLogin}
          >
            <img
              className="w-5 h-5"
              src={IconGoogle}
              alt="X icon"
            />
            <span className='font-inter font-semibold text-sm text-[#121212]'>
              Login with Google
            </span>
          </button>
        </div>
      </DialogContent>
    </Dialog>
    
    <AccountExistsModal />
    </>
  );
};

export default LoginModal;
